module.exports = __webpack_public_path__ + "static/img/service_content1_img.a0d16b3.png";